/* eslint-disable */
// @generated by protobuf-ts 2.8.2 with parameter add_pb_suffix,use_proto_field_name,ts_nocheck,eslint_disable
// @generated from protobuf file "brandguard.feedback.proto" (package "brandguardfeedback", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.FeedbackItem
 */
export interface FeedbackItem {
    /**
     * @generated from protobuf field: brandguardfeedback.Category category = 1;
     */
    category: Category;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: string severity = 3;
     */
    severity: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: string recommendation = 5;
     */
    recommendation: string;
    /**
     * @generated from protobuf field: string location = 6;
     */
    location: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.ExportRequest
 */
export interface ExportRequest {
    /**
     * @generated from protobuf field: string event_id = 1 [json_name = "event_id"];
     */
    event_id: string;
    /**
     * @generated from protobuf field: string event_type = 2 [json_name = "event_type"];
     */
    event_type: string;
    /**
     * @generated from protobuf field: string format = 3;
     */
    format: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.ExportResponse
 */
export interface ExportResponse {
    /**
     * @generated from protobuf field: string event_id = 1 [json_name = "event_id"];
     */
    event_id: string;
    /**
     * @generated from protobuf field: string event_type = 2 [json_name = "event_type"];
     */
    event_type: string;
    /**
     * @generated from protobuf field: string brand_name = 3 [json_name = "brand_name"];
     */
    brand_name: string;
    /**
     * @generated from protobuf field: string created_at = 4 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: int32 total_issues = 5 [json_name = "total_issues"];
     */
    total_issues: number;
    /**
     * @generated from protobuf field: int32 error_count = 6 [json_name = "error_count"];
     */
    error_count: number;
    /**
     * @generated from protobuf field: int32 warning_count = 7 [json_name = "warning_count"];
     */
    warning_count: number;
    /**
     * @generated from protobuf field: repeated brandguardfeedback.FeedbackItem items = 8;
     */
    items: FeedbackItem[];
    /**
     * @generated from protobuf field: string formatted_output = 9 [json_name = "formatted_output"];
     */
    formatted_output: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.EmailRequest
 */
export interface EmailRequest {
    /**
     * @generated from protobuf field: string event_id = 1 [json_name = "event_id"];
     */
    event_id: string;
    /**
     * @generated from protobuf field: string event_type = 2 [json_name = "event_type"];
     */
    event_type: string;
    /**
     * @generated from protobuf field: string recipient_email = 3 [json_name = "recipient_email"];
     */
    recipient_email: string;
    /**
     * @generated from protobuf field: string subject = 4;
     */
    subject: string;
    /**
     * @generated from protobuf field: string message = 5;
     */
    message: string;
    /**
     * selected_items contains the scorecard item types to include in the email.
     * Valid values: look_and_feel, brand_consistency, logo_detection, font_detection,
     * background_colors, violence, nudity
     *
     * @generated from protobuf field: repeated string selected_items = 6 [json_name = "selected_items"];
     */
    selected_items: string[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguardfeedback.EmailResponse
 */
export interface EmailResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string message = 2;
     */
    message: string;
}
/**
 * @generated from protobuf enum brandguardfeedback.Category
 */
export enum Category {
    /**
     * @generated from protobuf enum value: CATEGORY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CATEGORY_CONTENT_SAFETY = 1;
     */
    CONTENT_SAFETY = 1,
    /**
     * @generated from protobuf enum value: CATEGORY_CONTENT_QUALITY = 2;
     */
    CONTENT_QUALITY = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class FeedbackItem$Type extends MessageType<FeedbackItem> {
    constructor() {
        super("brandguardfeedback.FeedbackItem", [
            { no: 1, name: "category", kind: "enum", T: () => ["brandguardfeedback.Category", Category, "CATEGORY_"] },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "severity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "recommendation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FeedbackItem>): FeedbackItem {
        const message = { category: 0, type: "", severity: "", description: "", recommendation: "", location: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeedbackItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeedbackItem): FeedbackItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguardfeedback.Category category */ 1:
                    message.category = reader.int32();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string severity */ 3:
                    message.severity = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string recommendation */ 5:
                    message.recommendation = reader.string();
                    break;
                case /* string location */ 6:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeedbackItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguardfeedback.Category category = 1; */
        if (message.category !== 0)
            writer.tag(1, WireType.Varint).int32(message.category);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string severity = 3; */
        if (message.severity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.severity);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string recommendation = 5; */
        if (message.recommendation !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.recommendation);
        /* string location = 6; */
        if (message.location !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.FeedbackItem
 */
export const FeedbackItem = new FeedbackItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportRequest$Type extends MessageType<ExportRequest> {
    constructor() {
        super("brandguardfeedback.ExportRequest", [
            { no: 1, name: "event_id", kind: "scalar", localName: "event_id", jsonName: "event_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_type", kind: "scalar", localName: "event_type", jsonName: "event_type", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "format", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportRequest>): ExportRequest {
        const message = { event_id: "", event_type: "", format: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ExportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportRequest): ExportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_id = 1 [json_name = "event_id"];*/ 1:
                    message.event_id = reader.string();
                    break;
                case /* string event_type = 2 [json_name = "event_type"];*/ 2:
                    message.event_type = reader.string();
                    break;
                case /* string format */ 3:
                    message.format = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string event_id = 1 [json_name = "event_id"]; */
        if (message.event_id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.event_id);
        /* string event_type = 2 [json_name = "event_type"]; */
        if (message.event_type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.event_type);
        /* string format = 3; */
        if (message.format !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.format);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.ExportRequest
 */
export const ExportRequest = new ExportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportResponse$Type extends MessageType<ExportResponse> {
    constructor() {
        super("brandguardfeedback.ExportResponse", [
            { no: 1, name: "event_id", kind: "scalar", localName: "event_id", jsonName: "event_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_type", kind: "scalar", localName: "event_type", jsonName: "event_type", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_name", kind: "scalar", localName: "brand_name", jsonName: "brand_name", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "total_issues", kind: "scalar", localName: "total_issues", jsonName: "total_issues", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "error_count", kind: "scalar", localName: "error_count", jsonName: "error_count", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "warning_count", kind: "scalar", localName: "warning_count", jsonName: "warning_count", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => FeedbackItem },
            { no: 9, name: "formatted_output", kind: "scalar", localName: "formatted_output", jsonName: "formatted_output", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportResponse>): ExportResponse {
        const message = { event_id: "", event_type: "", brand_name: "", created_at: "", total_issues: 0, error_count: 0, warning_count: 0, items: [], formatted_output: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ExportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportResponse): ExportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_id = 1 [json_name = "event_id"];*/ 1:
                    message.event_id = reader.string();
                    break;
                case /* string event_type = 2 [json_name = "event_type"];*/ 2:
                    message.event_type = reader.string();
                    break;
                case /* string brand_name = 3 [json_name = "brand_name"];*/ 3:
                    message.brand_name = reader.string();
                    break;
                case /* string created_at = 4 [json_name = "created_at"];*/ 4:
                    message.created_at = reader.string();
                    break;
                case /* int32 total_issues = 5 [json_name = "total_issues"];*/ 5:
                    message.total_issues = reader.int32();
                    break;
                case /* int32 error_count = 6 [json_name = "error_count"];*/ 6:
                    message.error_count = reader.int32();
                    break;
                case /* int32 warning_count = 7 [json_name = "warning_count"];*/ 7:
                    message.warning_count = reader.int32();
                    break;
                case /* repeated brandguardfeedback.FeedbackItem items */ 8:
                    message.items.push(FeedbackItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string formatted_output = 9 [json_name = "formatted_output"];*/ 9:
                    message.formatted_output = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string event_id = 1 [json_name = "event_id"]; */
        if (message.event_id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.event_id);
        /* string event_type = 2 [json_name = "event_type"]; */
        if (message.event_type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.event_type);
        /* string brand_name = 3 [json_name = "brand_name"]; */
        if (message.brand_name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_name);
        /* string created_at = 4 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.created_at);
        /* int32 total_issues = 5 [json_name = "total_issues"]; */
        if (message.total_issues !== 0)
            writer.tag(5, WireType.Varint).int32(message.total_issues);
        /* int32 error_count = 6 [json_name = "error_count"]; */
        if (message.error_count !== 0)
            writer.tag(6, WireType.Varint).int32(message.error_count);
        /* int32 warning_count = 7 [json_name = "warning_count"]; */
        if (message.warning_count !== 0)
            writer.tag(7, WireType.Varint).int32(message.warning_count);
        /* repeated brandguardfeedback.FeedbackItem items = 8; */
        for (let i = 0; i < message.items.length; i++)
            FeedbackItem.internalBinaryWrite(message.items[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string formatted_output = 9 [json_name = "formatted_output"]; */
        if (message.formatted_output !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.formatted_output);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.ExportResponse
 */
export const ExportResponse = new ExportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailRequest$Type extends MessageType<EmailRequest> {
    constructor() {
        super("brandguardfeedback.EmailRequest", [
            { no: 1, name: "event_id", kind: "scalar", localName: "event_id", jsonName: "event_id", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_type", kind: "scalar", localName: "event_type", jsonName: "event_type", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "recipient_email", kind: "scalar", localName: "recipient_email", jsonName: "recipient_email", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "selected_items", kind: "scalar", localName: "selected_items", jsonName: "selected_items", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmailRequest>): EmailRequest {
        const message = { event_id: "", event_type: "", recipient_email: "", subject: "", message: "", selected_items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EmailRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailRequest): EmailRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_id = 1 [json_name = "event_id"];*/ 1:
                    message.event_id = reader.string();
                    break;
                case /* string event_type = 2 [json_name = "event_type"];*/ 2:
                    message.event_type = reader.string();
                    break;
                case /* string recipient_email = 3 [json_name = "recipient_email"];*/ 3:
                    message.recipient_email = reader.string();
                    break;
                case /* string subject */ 4:
                    message.subject = reader.string();
                    break;
                case /* string message */ 5:
                    message.message = reader.string();
                    break;
                case /* repeated string selected_items = 6 [json_name = "selected_items"];*/ 6:
                    message.selected_items.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string event_id = 1 [json_name = "event_id"]; */
        if (message.event_id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.event_id);
        /* string event_type = 2 [json_name = "event_type"]; */
        if (message.event_type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.event_type);
        /* string recipient_email = 3 [json_name = "recipient_email"]; */
        if (message.recipient_email !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.recipient_email);
        /* string subject = 4; */
        if (message.subject !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.subject);
        /* string message = 5; */
        if (message.message !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.message);
        /* repeated string selected_items = 6 [json_name = "selected_items"]; */
        for (let i = 0; i < message.selected_items.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.selected_items[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.EmailRequest
 */
export const EmailRequest = new EmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailResponse$Type extends MessageType<EmailResponse> {
    constructor() {
        super("brandguardfeedback.EmailResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmailResponse>): EmailResponse {
        const message = { success: false, message: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<EmailResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailResponse): EmailResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguardfeedback.EmailResponse
 */
export const EmailResponse = new EmailResponse$Type();
